import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ChevronRight from '@material-ui/icons/ChevronRight';
import NearbyCard from '../NearbyClinics/NearbyCard';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { smallerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import { isEmptyArray } from '../../../../../core/util/array';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { CDP_TOUCH_CLICK_TO_CALL_NEARBY_FIND_MORE } from '../../../../../core/analytics/events';
import { URGENT_CARE_NEAR_ME_PATH } from '../../../../../constants';
import { BASE_URL } from '../../../../../config';
import TrackImpression from '../../../../../core/tracking/impression/TrackNearbyLocationsImpression';
import { PRODUCT_TYPE } from '../../../../../core/tracking/impression/constants';

const NearbyClinicsContainer = styled.div`
  background-color: ${colors.fatherJohnMisty};
  padding: 15px 0;
  overflow: hidden;
`;

const NearbyClinicsText = styled.div`
  font-size: ${fontSize.extraLarge};
  font-family: ${fontFamily.bold};
  color: ${colors.squid};
  text-align: center;
  margin: 0 auto;
  padding: 0 10px;

  ${smallerThanOrEqualTo.md`
    font-size: ${fontSize.mediumLarge}
  `}
`;

const NearbyCardsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 15px -10px 15px 0;

  ${({ padded }) =>
    padded &&
    css`
      padding: 0 70px;
    `}
`;

const NearbyClinicCard = styled(NearbyCard)`
  flex-grow: 1;
  border-bottom: ${colors.dorianGrey} 1px solid;
  margin: 0 10px 1px 0;
  max-width: 500px;

  &:hover {
    background-color: ${colors.greyDim};
  }
`;

const FindMoreLink = styled.a`
  display: block;
  font-size: ${fontSize.mediumLarge};
  font-family: ${fontFamily.medium};
  color: ${colors.link};
  cursor: pointer;
  margin: 20px 0 0 20px;
  ${({ padded }) =>
    padded &&
    css`
      padding: 0 10px;
    `}

  svg {
    vertical-align: sub;
  }

  &:hover {
    text-decoration: underline;
  }

  ${smallerThanOrEqualTo.md`
    font-size: ${fontSize.medium}
  `}
`;

export default class NearbyPartners extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    nearbyPartnerClinics: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchPartnerClinics: PropTypes.func.isRequired,
    fullScreen: PropTypes.bool,
    className: PropTypes.string,
  };

  componentDidMount = () => this.props.fetchPartnerClinics(this.props.location);

  handleFindMore = () => {
    const { id, uclId } = this.props.location;
    const trackingProperties = {
      locationId: id,
      uclId,
    };
    analyticsTrackEvent(CDP_TOUCH_CLICK_TO_CALL_NEARBY_FIND_MORE, trackingProperties);
  };

  render = () => {
    const { nearbyPartnerClinics, fullScreen, className } = this.props;
    const nearby = nearbyPartnerClinics ? nearbyPartnerClinics.slice(0, 2) : [];
    if (isEmptyArray(nearby)) return null;
    return (
      <NearbyClinicsContainer className={className}>
        <NearbyClinicsText>Or Book Instantly at a Nearby Clinic</NearbyClinicsText>
        <NearbyCardsContainer padded={!fullScreen}>
          {!isEmptyArray(nearby) && (
            <Fragment>
              {nearby.map((clinic, i) => (
                <NearbyClinicCard key={i} location={clinic} />
              ))}
              <TrackImpression source={PRODUCT_TYPE.CLICK_TO_CALL} locationList={nearby} />
            </Fragment>
          )}
        </NearbyCardsContainer>
        <FindMoreLink
          href={`${BASE_URL}${URGENT_CARE_NEAR_ME_PATH}`}
          padded={fullScreen}
          onClick={this.handleFindMore}
        >
          Find More Urgent Care Clinics
          <ChevronRight />
        </FindMoreLink>
      </NearbyClinicsContainer>
    );
  };
}
